import React from "react";
import img from "./p2p.png";

const Concept = () => {
  return (
    <div>
      <img
        src={img}
        style={{ width: "100%", maxWidth: "600px" }}
        alt="peer-communication"
      />
      <p className="step-p">
        After receiving the longest valid chain, it will broadcast its latest block to its peers. 
      </p>

      <p className="step-p">
        Eventually, all the peers on the network will have the longest valid chain.
      </p>
    </div>
  );
};

export default Concept;


// WEBPACK FOOTER //
// ./src/steps/communicate-4/concept.js